<template>
    <table>
        <tr>
            <th class="header" colspan="3">ОЦЕНКА</th>
        </tr>
        <tr>
            <th>№</th>
            <th>Индикатор</th>
            <th class="result">Насколько соответствует поведение участника?</th>
        </tr>
        <tr v-for="(item, key) in assessment.body" v-bind:key="key">
            <td class="name">{{item.name}}</td>
            <td class="indicator">{{item.indicator}}</td>
            <td class="selector" :class="{ picked: !item.value }">
                <Selector :picked="item.value" :assessmentindex="key" :poolindex="poolindex"></Selector>
            </td>
        </tr>
        <tr>
            <td class="comments" colspan="3"><textarea :disabled="isDisabled" rows='3' v-model="message"
                                                       placeholder='Для комментариев'></textarea>
            </td>
        </tr>
    </table>

</template>

<script>
    import Selector from '@/components/Selector.vue'

    export default {
        name: "Assessment",
        props: ['assessment', 'poolindex'],
        computed: {
            message: {
                get() {
                    return this.assessment.comments
                },
                set(value) {
                    const payload = {comments: value, poolindex: this.poolindex};
                    this.$store.dispatch('SAVE_COMMENTS', payload)
                }
            },
            isDisabled() {
                return this.$store.getters.Q_ONE.status === 1
            }
        },
        components: {Selector}
    }
</script>

<style scoped>
    table {
        margin-top: 25px;
        width: 100%;
    }

    table, th, td {

        border: 1px solid black;
        border-collapse: collapse;
    }

    th, td {
        padding: 5px;
        text-align: center;
    }

    .result {
        width: 20%;
    }

    .indicator {
        text-align: left;
    }

    .name {
        width: 5%;
    }

    .header {
        background-color: darkgray;
    }

    textarea {
        width: 100%;
        overflow: auto;
        resize: vertical;
    }

    .comments {
        padding-left: 5px;
        padding-right: 10px;
    }

    .picked {
        background-color: #fadab2;
        border: solid red 3px;
    }

    .selector {
        text-align: left;
    }

</style>